import { useEffect, useState } from 'react';
import { emailRegExp } from '../../config/validators';

function ContactForm(props) {
	const { addContactError, alignLeft, buttonText, description, heading } =
		props;
	const [errors, setErrors] = useState({});
	const [formData, setFormData] = useState({
		email: '',
		message: '',
		name: '',
		phoneNumber: '',
	});
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	/**
	 * @returns {void}
	 */
	function handleResize() {
		setIsMobile(window.innerWidth < 768);
	}

	function handleOnChange(e) {
		const { id, value } = e.target;
		setFormData({ ...formData, [id]: value });
	}

	function handleOnSubmit(e) {
		e.preventDefault();

		const newErrors = validateFormData();

		if (Object.keys(newErrors).length) {
			setErrors(newErrors);
			return;
		}

		props.onSubmit(mapValues());
	}

	function validateFormData() {
		const newErrors = {};

		if (!emailRegExp.test(formData.email)) {
			newErrors.email =
				'Please enter a valid email address and try again';
		}

		if (!props.type) {
			return newErrors;
		}

		if (
			!formData.phoneNumber?.length ||
			formData.phoneNumber.replace(/[^\d]/g, '').length < 10
		) {
			newErrors.phoneNumber =
				'Please enter a valid phone number and try again';
		}

		if (!formData.name.trim()) {
			newErrors.name = 'Please enter a name and try again';
		}

		return newErrors;
	}

	function mapValues() {
		if (!props.type) {
			return {
				emailAddress: formData.email,
				name: mapNameToObject(formData.name),
			};
		}

		return {
			emailAddress: formData.email,
			name: mapNameToObject(formData.name),
			phoneNumber: formData.phoneNumber,
			message: formData.message || null,
		};
	}

	function mapNameToObject(name) {
		if (!name) {
			return {
				first: null,
				last: null,
			};
		}

		const trimmedName = name.trim();
		const words = trimmedName.split(' ');

		if (words.length === 1) {
			return {
				first: words[0] || null,
				last: null,
			};
		}

		return {
			first: words[0] || null,
			last: words[1] || null,
		};
	}

	function renderBaseFields() {
		return (
			<>
				<section className="text-left mb-4">
					<label
						className={`input-label ${
							props.type === 'contactMe'
								? 'input-label-required'
								: ''
						}`}
						htmlFor="name"
					>
						Name
					</label>
					<input
						className="input"
						id="name"
						placeholder="Enter your name..."
						required={props.type === 'contactMe' ? true : false}
						type="text"
						onChange={handleOnChange}
						value={formData.name}
					/>
					{errors.name ? (
						<p className="form-alert form-alert-error">
							{errors.name}
						</p>
					) : null}
				</section>

				<section className="text-left mb-4">
					<label
						className="input-label input-label-required"
						htmlFor="email"
					>
						Email
					</label>
					<input
						className="input"
						id="email"
						placeholder="Enter your email..."
						required={true}
						type="email"
						onChange={handleOnChange}
						value={formData.email}
					/>
					{errors.email ? (
						<p className="form-alert form-alert-error">
							{errors.email}
						</p>
					) : null}
				</section>
			</>
		);
	}

	function renderPhoneAndMessageFields() {
		if (!props.type) {
			return null;
		}

		return (
			<>
				<section className="text-left mb-4">
					<label
						className="input-label input-label-required"
						htmlFor="phoneNumber"
					>
						Phone
					</label>
					<input
						className="input"
						id="phoneNumber"
						placeholder="Enter your phone number..."
						required={true}
						type="tel"
						onChange={handleOnChange}
						value={formData.phoneNumber}
					/>
					{errors.phoneNumber ? (
						<p className="form-alert form-alert-error">
							{errors.phoneNumber}
						</p>
					) : null}
				</section>

				<section className="text-left">
					<label className="input-label" htmlFor="message">
						Message
					</label>
					<textarea
						className="input"
						cols={33}
						id="message"
						onChange={handleOnChange}
						placeholder="Enter your message..."
						rows={isMobile ? 2 : 3}
						value={formData.message}
					/>
				</section>
			</>
		);
	}

	return (
		<section className="my-2">
			<h1 className="-h-ms-1">{heading}</h1>
			<p className={`my-4 text-ms-0 ${alignLeft ? 'text-left' : ''}`}>
				{description}
			</p>
			{addContactError ? <p>{addContactError}</p> : null}
			<form onSubmit={handleOnSubmit}>
				{renderBaseFields()}
				{renderPhoneAndMessageFields()}
				<button
					className="button h-ms-1 md:h-ms-2 w-full mt-4"
					type="submit"
				>
					{buttonText}
				</button>
			</form>
		</section>
	);
}

export default ContactForm;
